'use strict';

class PrimaryImagesScroller {
    beforeScroll (e) {
        if (Foundation.MediaQuery.is('medium') && $('.primary-images .carousel-item:hover').length) {
            e.preventDefault();
            if (e.deltaY > 0) {
                $('.primary-images').slick('slickNext');
            } else if (e.deltaY < 0) {
                $('.primary-images').slick('slickPrev');
            }
        }
    }

    init () {
        if ($('.product-detail-keeper').length) {
            document.addEventListener('wheel', this.beforeScroll.bind(this), {passive: false});
        }
    }
}

const scroll = new PrimaryImagesScroller();
export default scroll;
